import { INDIAN_BANKS } from '@admin-panel/utils';
import { Input, Select, Space, type SelectProps } from 'antd';
import type { CSSProperties } from 'react';
import { useEffect, useRef, useState } from 'react';
const { Option } = Select;

const OTHER_BANK_VALUE = '__OTHER_BANK__';

type BankSelectorProps = Omit<SelectProps<string>, 'value' | 'onChange' | 'options'> & {
  value?: string;
  onChange?: (value?: string) => void;
  style?: CSSProperties;
};

export const BankSelector = ({ value, onChange, style, ...props }: BankSelectorProps) => {
  const [isOtherSelected, setIsOtherSelected] = useState(false);
  const isSelectingOtherBlankValueRef = useRef(false);

  useEffect(() => {
    if (!value) {
      if (isSelectingOtherBlankValueRef.current) {
        isSelectingOtherBlankValueRef.current = false;
        return;
      }
      setIsOtherSelected(false);
      return;
    }

    isSelectingOtherBlankValueRef.current = false;
    setIsOtherSelected(!INDIAN_BANKS.includes(value));
  }, [value]);

  const selectedValue = isOtherSelected ? OTHER_BANK_VALUE : value;

  return (
    <Space direction="vertical" size={8} style={{ width: 300, ...style }}>
      <Select<string>
        {...props}
        value={selectedValue}
        onChange={nextValue => {
          if (nextValue === OTHER_BANK_VALUE) {
            isSelectingOtherBlankValueRef.current = true;
            setIsOtherSelected(true);
            onChange?.('');
            return;
          }

          isSelectingOtherBlankValueRef.current = false;
          setIsOtherSelected(false);
          onChange?.(nextValue);
        }}
        style={{ width: '100%' }}
        placeholder="Select a bank"
        showSearch
        allowClear
      >
        {INDIAN_BANKS.map((bank, index) => (
          <Option key={index} value={bank}>
            {bank}
          </Option>
        ))}
        <Option value={OTHER_BANK_VALUE}>Other</Option>
      </Select>
      {isOtherSelected && (
        <Input
          value={value}
          placeholder="Enter bank name"
          onChange={event => onChange?.(event.target.value)}
        />
      )}
    </Space>
  );
};
